import { useNavigate } from "react-router-dom";
import { useLogoutMutation } from "@/entities/user";

export function useLogout() {
  const navigate = useNavigate();
  const logoutMutation = useLogoutMutation();

  const handleLogout = async () => {
    try {
      await logoutMutation.mutateAsync();
    } catch (err) {
      console.error("Ошибка при выходе:", err);
    } finally {
      navigate("/login");
    }
  };

  return {
    logout: handleLogout,
    isLoggingOut: logoutMutation.isPending,
  };
}
